import { setGlobalError } from 'containers/ErrorHandler/actions';
import globalMessages from 'translations/messages/global-messages';

export const extractErrorCode = error =>
  error?.data?.code ||
  error?.data?.response?.code ||
  error?.payload?.response?.code ||
  error?.response?.code ||
  error?.code;

export const extractErrorData = error =>
  error?.data || error?.payload?.response || error?.response || error;

export const dispatchGlobalErrorFromCatch = ({
  dispatch,
  error,
  defaultErrorMessageIntl = globalMessages.something_went_wrong,
  codeToMessageIntl = {},
}) => {
  const errorCode = extractErrorCode(error);
  const mappedMessage = codeToMessageIntl[errorCode];
  const customErrorMessageIntl = mappedMessage || defaultErrorMessageIntl;

  dispatch(
    setGlobalError({
      data: extractErrorData(error),
      customErrorMessageIntl,
    }),
  );

  return errorCode;
};
